import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnumSiNoTodos } from '../../../../core/_infrastructure/types/common';
import { FilterSearchingPeriodoCamViewModel, PeriodoCamItemResultsViewModel, PeriodoCamViewModel } from './periodocam.types';

@Injectable()
export class PeriodoCamService {
    private endpoint = this.baseUrl + 'api/mantenimiento/periodos/periodo/';
    private _periodoCam: PeriodoCamViewModel;
    private lastSearch?: FilterSearchingPeriodoCamViewModel;
    arrBooleanKeys = ['Parcela', 'Confeccion', 'Invernadero', 'EmpresaDeshidratacion'];
    arrDateKeys = ['FechaInicio', 'FechaFin'];

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    /**
     * Creates an HttpParms object through the values in the parameter.
     * @param payload FilterSearchingPeriodoCamViewModel
     * @returns HttpParams
     */
    private convertModelToHttpParms(payload: FilterSearchingPeriodoCamViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingPeriodoCamViewModel;

        for (k in payload) {
            let v: string | number | boolean | null;
            let valor = payload[k];
            if (this.arrBooleanKeys.indexOf(k) !== -1 && valor == EnumSiNoTodos.NO) {
                v = 0;
            } else if (this.arrDateKeys.indexOf(k) !== -1 && valor != null) {
                // v = this.toISOStringWithOffset(valor as Date);
                v = (valor as Date).toLocaleDateString();
            } else if (!(valor instanceof Date)) {
                v = valor!;
            } else {
                v = '';
            }
            params = params.append(k, v);
        }

        return params;
    }

    /**
     * Invokes the service to get the list of "Periodos", applying the filter in the parameter
     * @param payload FilterSearchingPeriodoCamViewModel
     * @returns Observable<PeriodoCamItemResultsViewModel>
     */
    getList(payload: FilterSearchingPeriodoCamViewModel): Observable<PeriodoCamItemResultsViewModel> {
        this.lastSearch = { ...payload }; // Keep for future search
        const params = this.convertModelToHttpParms(this.lastSearch);
        return this.getPagedByFilter(params);
    }

    /**
     * Invokes the service to get the list of "Periodos", applying the filter in the parameter
     * @param params HttpParams
     * @returns Observable<PeriodoCamItemResultsViewModel>
     */
    private getPagedByFilter(params: HttpParams): Observable<PeriodoCamItemResultsViewModel> {
        return this.http.get<PeriodoCamItemResultsViewModel>(this.endpoint + 'PagedByFilter/', { params: params });
    }

    delete(id: number): Observable<PeriodoCamViewModel> {
        return this.http.delete<PeriodoCamViewModel>(this.endpoint + id).pipe();
    }

    export(model: FilterSearchingPeriodoCamViewModel): Observable<HttpResponse<Blob>> {
        return this.http.post(this.endpoint + 'PostExportExcelByFilter', model, { observe: 'response', responseType: 'blob' });
    }

    getLastSearch(): FilterSearchingPeriodoCamViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }

    getById(id: number): Observable<PeriodoCamViewModel> {
        return this.http.get<PeriodoCamViewModel>(this.endpoint + id);
    }

    set periodoCam(periodoCam: PeriodoCamViewModel) {
        this._periodoCam = periodoCam;
    }

    get periodoCam(): PeriodoCamViewModel {
        return this._periodoCam;
    }

    save(payload: PeriodoCamViewModel): Observable<any> {
        // delete model.Descripcion;  // Para forzar un fallo en el backend y ver que pasa en el catchError
        if (payload?.Id) {
            return this.edit(payload);
        }
        return this.create(payload);
    }

    private create(payload: PeriodoCamViewModel): Observable<any> {
        return this.http.post<PeriodoCamViewModel>(this.endpoint, payload);
    }

    private edit(payload: PeriodoCamViewModel): Observable<any> {
        return this.http.put<PeriodoCamViewModel>(this.endpoint, payload);
    }

    clonePeriodo(idPeriodo: number): Observable<any> {
        return this.http.get<PeriodoCamViewModel>(this.endpoint + 'clonePeriodo/' + idPeriodo).pipe();
    }

    getPeriodoEsVigente(id: number): Observable<boolean> {
        return this.http.get<boolean>(this.endpoint + 'esVigente/' + id);
    }

    getPeriodoEnPlazoPresentacionVigente(id: number): Observable<boolean> {
        return this.http.get<boolean>(this.endpoint + 'esPlazoPresentacionVigente/' + id);
    }
}
